import { CardPayment } from 'types/state';
import { createUserProfileInfoMock } from 'utils/dataMocks';
import { createM8RateDTOMock } from 'utils/m8RateDTOUtils';
import {
  createPaymentTransactionBYNMock,
  createPaymentTransactionUSDMock,
} from 'utils/paymentUtils';
import { createRandomBoolean } from 'utils/randomBooleanUtils';
import { createUniqueRuntimeNumber } from 'utils/uniqueRuntimeNumberUtils';

export const createCardPaymentMock = (id: number): CardPayment => ({
  id,
  description: `Платеж ${id}`,
  creditedTransaction: createPaymentTransactionUSDMock(),
  recievedTransaction: createPaymentTransactionBYNMock(),
  exchangeRate: createM8RateDTOMock(),
  updatedAt: new Date().toISOString(),
  createdAt: new Date().toISOString(),
  orderId: 'ABCDE1234',
  userId: createUniqueRuntimeNumber(),
  userProfile: createUserProfileInfoMock(),
  status: createRandomBoolean()
    ? 'CREATED'
    : createRandomBoolean()
    ? 'DECLINED'
    : createRandomBoolean()
    ? 'DEPOSITED'
    : 'REVERSED',
});
